import React from 'react'

import { PERFORMANCE_CHART_LABEL } from 'utils/testing/testIDs'

import { getRecapQuarter } from '../../helpers'
import { MonthLabel, MonthWrapper } from './styled-components'

export const ChartLabel = ({
  endsAt,
  startsAt,
}: {
  endsAt: string
  startsAt: string
}): React.ReactElement => {
  const { recapQuarter } = getRecapQuarter({ endsAt, startsAt })

  return (
    <MonthWrapper data-testid={PERFORMANCE_CHART_LABEL}>
      {recapQuarter.map((month) => (
        <MonthLabel key={month}>{month.toUpperCase()}</MonthLabel>
      ))}
    </MonthWrapper>
  )
}
